import React from 'react';

import Space from 'v3/components/Space';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';

import { useClient } from '../context';

export default function Editable({ isEditing, setEditing, onSave, isLoading, add, openModal }) {
  const client = useClient();

  function handleCancel() {
    setEditing(false);
    client.setData(client.prevClient);
    client.setErrors({});
  }

  if (isEditing) {
    return (
      <Space x="5px">
        <Button variant="secondary" onClick={handleCancel} className="py-2">
          <Text type="regular" color="dark" weight="500">
            Cancelar
          </Text>
        </Button>
        <Button variant="primary" onClick={onSave} loading={isLoading} className="py-2">
          <Text type="regular" color="white" weight="500">
            Salvar
          </Text>
        </Button>
      </Space>
    );
  }

  return (
    <>
      {add ? (
        <Button variant="primary" onClick={() => openModal()} className="py-2">
          <Text color="white" weight="500" type="regular">
            Adicionar
          </Text>
        </Button>
      ) : (
        <Button variant="secondary" onClick={() => setEditing(true)} className="py-2">
          <Text color="dark" weight="500" type="regular">
            Editar
          </Text>
        </Button>
      )}
    </>
  );
}
